<avi-card class="license-card">
    <avi-card_header>
        <div class="license-card__header">
            <div class="license-card__title">
                <cds-icon
                    shape="certificate"
                    status="success"
                    size="24"
                ></cds-icon>
                {{ globalL10nKeys.licenseLabel | vtranslate }}
            </div>
        </div>
    </avi-card_header>
    <avi-card_body>
        <div
            class="license-card__license-body"
            *ngIf="!isBusy; else loaderTemplate"
        >
            <license-card-content
                [availableServiceCores]="availableServiceCores"
                [reservedServiceCores]="reservedServiceCores"
                [usedServiceCores]="usedServiceCores"
                [orgServiceUnits]="orgServiceUnits"
                [licensePool]="licensePool"
                [licenseTier]="licenseTier"
            ></license-card-content>
        </div>
        <ng-template #loaderTemplate>
            <div class="license-card__spinner">
                <clr-spinner clrMedium></clr-spinner>
            </div>
        </ng-template>
    </avi-card_body>
</avi-card>
